import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { PRICING, PRICING_OPTIONS, VALUE_STACK } from '../../data/content';
export function ValueStack() {
  const product = PRICING_OPTIONS[0];
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-290" data-mp="1bu6d5pj03daj">
      <div className="mx-auto max-w-3xl" data-id="element-291" data-mp="1bupmihul4tcy">
        <Reveal className="text-center" data-id="element-292" data-mp="o4lkug0yj3ol">
          <SectionBadge data-id="element-293" data-mp="o5n3b5kaysgc">El paquete completo</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-3xl leading-tight text-cocoa sm:text-5xl" data-id="element-294" data-mp="k3076sglmldc">
            Todo lo que recibís <span className="italic text-terra" data-id="element-295" data-mp="xuoorb9ma21p">en un solo lugar</span>
          </h2>
        </Reveal>

        <Reveal delay={60} className="mt-10" data-id="element-296" data-mp="t2nchpcg8bbo">
          <div className="overflow-hidden rounded-2xl border border-sand-line bg-cream-card" data-id="element-297" data-mp="t1vgidexwbkv">
            <ul data-id="element-298" data-mp="5c141wyj8p15">
              {VALUE_STACK.map(item => <li key={item.label} className="flex items-start justify-between gap-3 border-b border-sand-line px-4 py-4 last:border-b-0 sm:gap-4 sm:px-6" data-id="element-299" data-mp="fsv51axhs2f">
                  <span className="flex items-start gap-3" data-id="element-300" data-mp="2jo7v0jtw3e25">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-olive" aria-hidden="true" data-id="element-301" data-mp="2onu7gr1w8q9w" />
                    <span data-id="element-302" data-mp="2th6ifydngyk6">
                      <span className="block text-sm font-bold text-cocoa" data-id="element-303" data-mp="2thye1978ywag">{item.label}</span>
                      <span className="mt-0.5 block text-xs text-cocoa-dim" data-id="element-304" data-mp="2yh1a44591s6a">{item.detail}</span>
                    </span>
                  </span>
                  <span className={`whitespace-nowrap text-sm ${item.strike ? 'text-cocoa-dim line-through' : 'font-bold text-cocoa'}`} data-id="element-305" data-mp="25prg45lvih8x">
                    {item.value}
                  </span>
                </li>)}
            </ul>

            <div className="flex items-center justify-between gap-3 bg-cream-deep px-4 py-4 sm:gap-4 sm:px-6" data-id="element-306" data-mp="2esirk5er1d0k">
              <span className="text-xs font-extrabold uppercase tracking-wide text-cocoa sm:text-sm" data-id="element-307" data-mp="3m49gyqibt9af">Valor total real</span>
              <span className="whitespace-nowrap font-display text-2xl text-cocoa-dim line-through sm:text-3xl" data-id="element-308" data-mp="3q7yywx4hwsmh">{PRICING.totalValueOld}</span>
            </div>
          </div>
        </Reveal>

        {product && <Reveal delay={100} className="mt-4" data-id="element-309" data-mp="2022hu55a6zx8">
            <div className="rounded-2xl bg-cocoa px-6 py-8 text-center" data-id="element-310" data-mp="200rgsd38069t">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-311" data-mp="1v2g2nq5w79ls">Precio de hoy</p>
              <p className="mt-3 font-display text-[52px] leading-none text-cream sm:text-6xl" data-id="element-312" data-mp="17clrdd181t3n">
                {product.price}{' '}
                <span className="font-sans text-base font-bold text-cream/70" data-id="element-313" data-mp="13dmr45qfqkij">{PRICING.currency}</span>
              </p>
              <p className="mt-3 text-sm font-semibold text-cream/75" data-id="element-314" data-mp="1h51e0nngr5uv">
                Un pago único · acceso inmediato · <span className="text-cream" data-id="element-315" data-mp="omw1938elvi2">100% digital</span>
              </p>
            </div>
          </Reveal>}
      </div>
    </section>;
}